import { toast, ToastOptions, Id } from 'react-toastify';
import React from 'react';

interface ToastConfig {
  title: string;
  message?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

// Composants d'icônes pour les toasts
const SuccessIcon = () => (
  <div className="Toastify__toast-icon Toastify__toast-icon--success">✓</div>
);

const ErrorIcon = () => (
  <div className="Toastify__toast-icon Toastify__toast-icon--error">✕</div>
);

const WarningIcon = () => (
  <div className="Toastify__toast-icon Toastify__toast-icon--warning">⚠</div>
);

const InfoIcon = () => (
  <div className="Toastify__toast-icon Toastify__toast-icon--info">ℹ</div>
);

const ToastContent: React.FC<ToastConfig & { icon?: React.ReactNode }> = ({ title, message, action, icon }) => {
  // Utiliser le message comme contenu principal, ou le titre si pas de message
  const content = message || title;
  
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
      {icon}
      <div className="Toastify__toast-content">
        <div className="Toastify__toast-message">{content}</div>
        {action && (
          <div className="Toastify__toast-action">
            <button onClick={action.onClick}>{action.label}</button>
          </div>
        )}
      </div>
    </div>
  );
};

export const showToast = {
  success: (config: ToastConfig, options?: ToastOptions): Id => {
    return toast.success(<ToastContent {...config} icon={<SuccessIcon />} />, {
      ...options,
    });
  },

  error: (config: ToastConfig, options?: ToastOptions): Id => {
    return toast.error(<ToastContent {...config} icon={<ErrorIcon />} />, {
      ...options,
    });
  },

  warning: (config: ToastConfig, options?: ToastOptions): Id => {
    return toast.warning(<ToastContent {...config} icon={<WarningIcon />} />, {
      ...options,
    });
  },

  info: (config: ToastConfig, options?: ToastOptions): Id => {
    return toast.info(<ToastContent {...config} icon={<InfoIcon />} />, {
      ...options,
    });
  },
};

// Fonction de compatibilité pour les anciens appels
export const toastSuccess = (message: string, title?: string) => {
  return showToast.success({
    title: title || 'Succès',
    message,
  });
};

export const toastError = (message: string, title?: string) => {
  return showToast.error({
    title: title || 'Erreur',
    message,
  });
};

export const toastWarning = (message: string, title?: string) => {
  return showToast.warning({
    title: title || 'Attention',
    message,
  });
};

export const toastInfo = (message: string, title?: string) => {
  return showToast.info({
    title: title || 'Information',
    message,
  });
};
